// src/components/Layout/MainLayout.jsx
import React from 'react';
import Sidebar from '../Sidebar/Sidebar';

const MainLayout = ({ children, selectedTool, onSelectTool, creditBalance }) => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen h-screen bg-neutral-50 overflow-hidden">
      {/* Narrower Sidebar */}
      <Sidebar 
        selectedTool={selectedTool} 
        onSelectTool={onSelectTool} 
        creditBalance={creditBalance} 
      />
      
      {/* Compact main content area - with same height as sidebar */}
      <main className="flex-1 pt-16 md:pt-0 md:pl-0 overflow-y-auto h-full">
        <div className="container mx-auto px-4 py-4">
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;